import { render, staticRenderFns } from "./BDXEditFormCoverholder.vue?vue&type=template&id=42769d3d&scoped=true"
import script from "./BDXEditFormCoverholder.vue?vue&type=script&lang=js"
export * from "./BDXEditFormCoverholder.vue?vue&type=script&lang=js"
import style0 from "./BDXEditFormCoverholder.vue?vue&type=style&index=0&id=42769d3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42769d3d",
  null
  
)

export default component.exports